import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import DarkModeToggle from './DarkMode';
import '../styles/Navbar.css';

export default function Navbar({ toggleTheme }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="nav-left">
        <Link to="/" className="logo" onClick={closeMenu}>
          <img src="/images/logo.png" alt="Vanessa Logo" style={{ height: '40px' }} />
          <span className="logo-text">Vanessa Victorino</span>
        </Link>
      </div>

      {/* Hamburger icon */}
      <div className="hamburger" onClick={toggleMenu}>
        <div className={menuOpen ? 'bar open' : 'bar'}></div>
        <div className={menuOpen ? 'bar open' : 'bar'}></div>
        <div className={menuOpen ? 'bar open' : 'bar'}></div>
      </div>

      {/* Links */}
      <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
        <Link to="/home" onClick={closeMenu}>Home</Link>
        <Link to="/about" onClick={closeMenu}>About</Link>
        <Link to="/projects" onClick={closeMenu}>Projects</Link>
        <Link to="/contact" onClick={closeMenu}>Contact</Link>
        <DarkModeToggle />
      </div>
    </nav>
  );
}
